import { DashboardSection } from '../../types';

import ActivePanel from './panels/ActivePanel';
import ConfigPanel from './panels/ConfigPanel';
import QueuesPanel from './panels/QueuesPanel';
import RecentStatusPanel from './panels/RecentStatusPanel';
import UnackedPanel from './panels/UnackedPanel';

export const celerySection: DashboardSection = {
  key: 'celery',
  label: 'Celery',
  tabs: [
    {
      key: 'overview',
      label: 'Overview',
      render: (interval) => (
        <>
          <QueuesPanel interval={interval} />
          <ActivePanel interval={interval} />
        </>
      )
    },
    {
      key: 'unacked',
      label: 'Unacked',
      render: (interval) => <UnackedPanel interval={interval} />
    },
    {
      key: 'history',
      label: 'Task history',
      render: (interval) => <RecentStatusPanel interval={interval} />
    },
    {
      key: 'celery-config',
      label: 'Celery Config',
      render: (interval) => <ConfigPanel interval={interval} />
    }
  ]
};
